<template>
  <div>
    <el-dialog title="添加线下收款数据" :visible.sync="dialogVisible" :append-to-body="true" width="30%">
      <div class="lineP">
        <p style="font-size:18px;">团号：{{ $store.state.planId}}</p>
        <p v-if="showEditArr.indexOf('payDate')!=-1"><span>客户付款时间：</span><el-date-picker v-model="addCollectionDetail.payDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker></p>
        <p v-if="showEditArr.indexOf('payName')!=-1">
          <span>付款方名称：</span>
          <el-autocomplete v-model="addCollectionDetail.payName" :fetch-suggestions="querySearchAsync"
            @select="handleSelect">
            <template slot-scope="{ item }">
              <div class="name">{{item.payName}}</div>
            </template>
          </el-autocomplete>
        </p>
        <p v-if="showEditArr.indexOf('payPrice')!=-1"><span>收款金额：</span><el-input v-model="addCollectionDetail.payPrice"></el-input>{{addCollectionDetail.currency}}</p>
        <p v-if="showEditArr.indexOf('rate')!=-1"><span>汇率：</span><el-input v-model="addCollectionDetail.rate"></el-input></p>
        <p v-if="showEditArr.indexOf('remark')!=-1"><span>备注：</span><el-input v-model="addCollectionDetail.remark"></el-input></p>
        <div v-if="showEditArr.indexOf('file')!=-1">
          <p v-if="addCollectionDetail.waterVoucher&&addCollectionDetail.waterVoucher!=''">
            <span>已上传图片:<img :src="addCollectionDetail.waterVoucher"/></span>
          </p>
          <upload :picLimit="1" ref="upload" style="    margin-top: 0.1rem;"></upload>
        </div>
      </div>
      <p style="color:red">注：请仔细核对你的信息是否正确，收款数据一旦确认无法更改</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureAddUnderLine" :loading="sureAddUnderLineFlag">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PayApi from "@/components/Api/pay";
import upload from '../../../../../plan/leftMoudle/children/upload.vue';
import { mapState } from "vuex"
export default {
  components: { upload },
  computed: {
    ...mapState(['planId'])
  },
  data(){
    return{
      dialogVisible:false,
      addCollectionDetail:{
        payDate:null,
        collectionId:null,
        payName:null,
        payPrice:null,
        remark:'',
        rate:1,
        currency:'',
      },
      showEditArr:['payDate','payName','payPrice','rate','remark','file'],
      sureAddUnderLineFlag:false,
    }
  },
  methods:{
    handleSelect(item){
      this.addCollectionDetail.payName = item.payName
    },
    querySearchAsync(queryString, cb) {
      new PayApi("pay").querySearchAsync({payName:queryString}).then(res => {
        if (res.status == 200) {
          cb(res.data);
        }
      })
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        // 创建一个新的 FileReader 对象
        const reader = new FileReader();
        // 读取 File 对象
        reader.readAsDataURL(file);
        // 加载完成后
        reader.onload = function () {
          // 将读取的数据转换为 base64 编码的字符串
          const base64String = reader.result;
          // 解析为 Promise 对象，并返回 base64 编码的字符串
          resolve(base64String);
        };
        // 加载失败时
        reader.onerror = function () {
          reject(new Error("Failed to load file"));
        };
      });
    },
    postAddCollectionDetail(){
      this.sureAddUnderLineFlag = true
      new PayApi("pay").addCollectionDetail(this.addCollectionDetail).then(res => {
        this.sureAddUnderLineFlag = false
        if (res.status == 200) {
          this.dialogVisible=false
          this.addCollectionDetail.payName=null
          this.$emit("getList",this.addCollectionDetail.collectionId)
          this.addCollectionDetail={
            payDate:null,
            payName:null,
            remark:''
          }
          this.$refs.upload.$refs.upload.clearFiles()
        }
      }).catch(res=>{
        this.sureAddUnderLineFlag = false
      })
    },
    sureAddUnderLine(){
      if(this.$refs.upload&&this.$refs.upload.fileList.length>0){
        this.fileToBase64(this.$refs.upload.fileList[0].raw).then(base64 => {
          this.addCollectionDetail.waterVoucherBase64 = base64
          this.addCollectionDetail.waterVoucherName = this.$refs.upload.fileList[0].name
          this.postAddCollectionDetail()
        })
      }else{
        this.postAddCollectionDetail()
      }
    },
    openDailog(item){
      this.dialogVisible = true
      this.addCollectionDetail.collectionId = item.id
      this.addCollectionDetail.currency = item.currency
      this.$set(this.addCollectionDetail,'payPrice',item.feeAmount)
      this.addCollectionDetail.payDate = this.dateFormatYMD(new Date().getTime(),"-")
    },
    openDailog1(item,flag){
      this.showEditArr = ['payDate','payName','payPrice','rate','remark','file']
      this.dialogVisible = true
      if(flag&&flag.length>0) this.showEditArr=flag
      this.addCollectionDetail.id = item.id
      this.addCollectionDetail.collectionId = item.collectionId
      this.addCollectionDetail.currency = item.currency
      this.addCollectionDetail.payPrice = item.payPrice
      this.addCollectionDetail.payName = item.payName
      this.addCollectionDetail.waterVoucher = item.waterVoucher
      this.addCollectionDetail.payDate = this.dateFormatYMD(item.payDate,"-")
    }
  }
}
</script>

<style lang="scss" scoped>
.lineP{
  >p{
    margin-top: 0.1rem;
    display: flex;
    align-items: center;
    >div{
      width: 2rem;
    }
    >span{
      width: 1rem;
      display: inline-block;
    }
  }
}
</style>